import myHeader from "../../components/header.vue"
import myFooter from "../../components/footer.vue"
import OfflineCourse from '../offlineCourseList2/offlineCourseList.vue'
import {
  pUrl
} from "@/api/baseURL.js";
import {
  getCourseCatetoryPatentFromHome,
  getStudyCentreList,
  getCourseCatetorySubsetFromHome,
} from "@/apiCloud/publicCourse";

import { mapGetters } from 'vuex'
import store from '@/store'

export default {
  components: {
    myHeader,
    myFooter,
    OfflineCourse
  },
  data() {
    return {
      showOffline: false,
      oneTypeList: [],
      oneTypeList1: [{
          cateName: "专业课程",
          newName: "职业认证",
          cateId: '0'
        }, {
          cateName: "私有课程",
          newName: "职业提升",
          cateId: '2'
        },
        // {
        //   cateName: "线下课程",
        //   cateId: '3'
        // }
      ],
      oneTpyeId1: 0,
      secondTypeList: [],
      tabSelect: "0",
      oneTpyeId: '',
      secondTypeId: '',
      courseList: [],
      tabsList: [{
          title: "最热"
        },
        {
          title: "最新"
        }
      ],
      pageSize: 16,
      total: 0,
      pageNum: 1,
      aa: true,
      isJx: false,
      courseType: "",
      searchWord: ""
      // minHeight:document.getElementById("publicCourse"),
    }
  },
  computed:{
    ...mapGetters(['entpType'])
  },
  // 历史遗留问题，等待获取配置信息
  beforeRouteEnter(to, from, next){
    let waitTime = 0
    if(store.getters.entpType != ''){
      next()
      return
    }
    let t = setInterval(()=>{
      waitTime+=1
      if(waitTime==20 || store.getters.entpType != ''){
        console.log('wait',waitTime)
        clearInterval(t)
        t= null
        next()
      }
    },300)
  },
  created() {
    this.courseType = this.oneTypeList1[0].cateName
    // console.log(1111,this.minHeight)
    var parentId = this.$route.query.parentId
    var childId = this.$route.query.childId
    this.oneTpyeId1 = this.$route.query.courseSource ? this.$route.query.courseSource : 0;
    if(this.entpType=='2'){
      this.oneTpyeId1 = '2'
      this.courseType = '私有课程'
    }
    if (parentId && childId) {
      this.oneTpyeId = parentId
      this.secondTypeId = childId
      this.aa = true
      if (this.$route.query.offline == 1) {
        return;
      }
      this.getOneTypeList(this.oneTpyeId1)
    } else if (parentId) {
      this.oneTpyeId = parentId
      if (this.$route.query.offline == 1) {
        return;
      }
      this.getOneTypeList(this.oneTpyeId1)
    } else {
      if (this.$route.query.offline == 1) {
        return;
      }
      this.getOneTypeList(this.oneTpyeId1)
    }
    //     var pUrl=window.location.href;
    //    // 是否是江西代理商访问
    //        if(pUrl=="http://jx.eceping.net"||pUrl.substring(0,pUrl.indexOf("/",7))=="http://jx.eceping.net"||pUrl.substring(0,pUrl.indexOf("/",7))=="http:/jx.eceping.net:8080"){//jx.eceping.net域名时,显示关于我们
    //        console.log(1111,this.isJx)
    //        this.isJx=true;
    //    }
    if (localStorage.getItem("isJx") == "true") { // 是否是江西代理商访问
      this.isJx = true;
    }
  },
  mounted() {
    var publicCourse = document.getElementById("publicCourse")
    publicCourse.style.minHeight = document.body.scrollHeight - 90 + "px";

    if (this.$route.query.offline == 1) {
      this.getSecondType1('3', {
        cateName: "线下课程",
        cateId: '3'
      })
      this.courseList
    }
  },
  destory() {

  },
  watch: {},
  // updated(){
  //     window.scroll(0,0)
  // },
  methods: {
    getSecondType1(cateId, obj) {
      this.courseType = obj.cateName;
      this.oneTpyeId1 = cateId;
      this.oneTypeList = [];
      this.secondTypeList = [];
      this.oneTpyeId = 0;
      this.secondTypeId = 0;

      if (cateId == 3) {
        this.showOffline = true;
        return;
      } else {
        this.showOffline = false;
      }

      this.getOneTypeList(cateId);
      /*  if(cateId==="0"){
          this.getOneTypeList(cateId);
        }else {
          this.oneTypeList=[];
          this.secondTypeList=[];
          this.oneTpyeId=0;
          this.secondTypeId=0;
          this.getcourseList();
        }*/
    },
    // 一级分类
    getOneTypeList(courseSource) {
      var param = {
        courseSource: courseSource
      };
      getCourseCatetoryPatentFromHome(param).then(res => {
        if (res.code == 200) {
          this.oneTypeList = res.data
          this.oneTypeList.unshift({
            cateName: "全部",
            cateId: ''
          })
          this.getSecondType(this.oneTpyeId)
        }
      })
    },
    // 点击一级分类获取二级分类
    getSecondType(cateId) {
      this.pageNum = 1
      if (cateId == "") {
        this.oneTpyeId = cateId
        this.secondTypeList = []
        this.secondTypeId = ''
        this.getcourseList()
      } else {
        this.oneTpyeId = cateId
        let data = {
          entpId: '',
          courseSource: this.oneTpyeId1,
          catePatentId: cateId,
          // courseSource: 0,
        }
        getCourseCatetorySubsetFromHome(data).then(res => {
          if (res.code == 200) {
            this.secondTypeList = res.data
            this.secondTypeList.unshift({
              cateName: "全部",
              cateId: ''
            })
            if (!this.aa) {
              this.secondTypeId = ''
            }
            this.aa = false
            this.secondTypeClick(this.secondTypeId)
          }
        })
      }
    },
    // 二级分类点击
    secondTypeClick(cateId) {
      this.secondTypeId = cateId
      this.pageNum = 1
      this.getcourseList()
    },
    //最新最热
    addTabsClass(index) {
      this.pageNum = 1
      this.tabSelect = index
      this.getcourseList()
    },
    searchList() {
      let data = {
        entpId: '',
        catePatentId: this.oneTpyeId,
        cateId: this.secondTypeId,
        orderby: this.tabSelect,
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        courseSource: this.oneTpyeId1 == "3" ? "" : this.oneTpyeId1,
        courseName: this.searchWord
      }
      getStudyCentreList(data).then(res => {
        if (res.code == 200) {
          // this.courseList = res.rows.filter(fitem=>fitem.ccIdCount>0)
          this.courseList = res.rows
          if(this.courseList.length==0){
            res.total = 0
          }
          this.total = res.total
        }
      })
    },
    // 获取课程列表
    getcourseList() {
      $('html,body').animate({
        scrollTop: '0px'
      }, 500)
      let data = {
        entpId: '',
        catePatentId: this.oneTpyeId,
        cateId: this.secondTypeId,
        orderby: this.tabSelect,
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        courseSource: this.oneTpyeId1 == "3" ? "" : this.oneTpyeId1
      }
      getStudyCentreList(data).then(res => {
        if (res.code == 200) {
          this.courseList = res.rows.filter(fitem=>fitem.ccIdCount>0)
          if(this.courseList.length==0){
            res.total = 0
          }
          this.total = res.total
        }
      })

    },

    //分页
    currentChange(page) {
      this.pageNum = page
      this.getcourseList()
      // window.scrollTo(0,0)
    },
    GotoCourseDetail(id, packagebagId, regId) {
      this.$router.push({
        name: "courseDetail",
        params: {
          courseId: id,
          packagebagId,
          oldPage: 1,
          courseType: this.courseType
        }
      });
      sessionStorage.setItem('returnRouteBack', 'publicCourse')
      localStorage.setItem("packagebagId", packagebagId)
      // localStorage.setItem("studyRegId", regId);
      localStorage.setItem("courseId", id)
      localStorage.setItem("courseType", this.courseType)
    },
    //设置高度
    // setHeight(){
    //     let offsetHeight=document.body.offsetHeight
    //     let height=offsetHeight-60-200
    // },
  },

}



// WEBPACK FOOTER //
// ./src/pages/publicCourse/publicCourse.js